.switch-container {
    width: 70px;
}
